module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Saphorin-coat_of_arms-b69d0197d063aebb12134fa4e04a8642.svg";